import { cn } from "@/lib/utils";
import { statisticsSidebarSurfaceCardClassName } from "../Statistics/components/statisticsShadcnCardShell";

/** Inset surface for tables on account settings — matches parent card surface. */
export const accountSettingsInsetSurfaceClassName = cn(
  "account-settings-inset-surface overflow-hidden rounded-md border border-solid border-border shadow-none ring-0",
  statisticsSidebarSurfaceCardClassName,
);

/** Account settings cards — sidebar surface in dark mode (matches University / Strategies). */
export const accountSettingsSettingCardClassName = cn(
  "rounded-md border border-solid border-border bg-card text-card-foreground shadow-none ring-0",
  statisticsSidebarSurfaceCardClassName,
);

export const accountSettingsSettingCardNoteClassName =
  "rounded-b-md border border-t border-border bg-muted/50 px-6 py-3 font-[family-name:var(--font-primary)] text-xs text-gray-500 dark:text-white";

/** Body / field descriptions on account settings cards — gray-500 in light, white in dark. */
export const accountSettingsFieldDescriptionClassName =
  "font-[family-name:var(--font-primary)] text-sm font-normal leading-normal text-gray-500 dark:text-white";

/** Emphasized values inline with field descriptions (thresholds, progress amounts, etc.). */
export const accountSettingsFieldValueClassName =
  "font-medium text-gray-500 dark:text-white";

/** Nested list/detail cards inside account settings (sign-in methods, notifications, milestones). */
export const accountSettingsNestedCardClassName = cn(
  "account-settings-nested-card flex w-full min-w-0 flex-col gap-0 overflow-visible rounded-md border border-solid border-border bg-card py-0 text-card-foreground shadow-none ring-0",
  statisticsSidebarSurfaceCardClassName,
);

/** Account settings select label text — gray-500 in light, white in dark (sidebar cards). */
const accountSettingsFieldSelectTextClass =
  "text-gray-500 dark:text-white hover:!text-gray-500 dark:hover:!text-white data-[state=open]:!text-gray-500 dark:data-[state=open]:!text-white focus-visible:!text-gray-500 dark:focus-visible:!text-white";

/** Full-width selects on account settings cards (display preferences, timezone, milestones, etc.). */
export const accountSettingsFieldSelectTriggerClassName = cn(
  "w-full font-[family-name:var(--font-primary)] text-sm font-normal",
  accountSettingsFieldSelectTextClass,
  "[&_[data-slot=select-value]]:text-gray-500 dark:[&_[data-slot=select-value]]:text-white",
  "hover:[&_[data-slot=select-value]]:!text-gray-500 dark:hover:[&_[data-slot=select-value]]:!text-white",
  "data-[state=open]:[&_[data-slot=select-value]]:!text-gray-500 dark:data-[state=open]:[&_[data-slot=select-value]]:!text-white",
  "focus-visible:[&_[data-slot=select-value]]:!text-gray-500 dark:focus-visible:[&_[data-slot=select-value]]:!text-white",
  "[&_svg]:text-gray-500 dark:[&_svg]:text-white",
  "hover:[&_svg]:!text-gray-500 dark:hover:[&_svg]:!text-white",
  "data-[state=open]:[&_svg]:!text-gray-500 dark:data-[state=open]:[&_svg]:!text-white",
  "focus-visible:[&_svg]:!text-gray-500 dark:focus-visible:[&_svg]:!text-white",
);

export const accountSettingsFieldSelectContentClassName = cn(
  "!z-[120] text-gray-500 dark:text-white",
);

export const accountSettingsFieldSelectItemClassName = cn(
  "whitespace-normal break-words font-[family-name:var(--font-primary)] font-normal text-gray-500 dark:text-white",
  "data-highlighted:!text-gray-500 focus:!text-gray-500 data-[state=checked]:!text-gray-500",
  "data-highlighted:**:!text-gray-500 focus:**:!text-gray-500 data-[state=checked]:**:!text-gray-500",
  "dark:data-highlighted:!text-white dark:focus:!text-white dark:data-[state=checked]:!text-white",
  "dark:data-highlighted:**:!text-white dark:focus:**:!text-white dark:data-[state=checked]:**:!text-white",
);
